import { FormType } from '@/core/models/form-type.enum';

export interface ContractTemplateFieldName {
   id: number;
   key: ContractTemplateFieldNameKey;
   model: string;
   resource_endpoint: string;
   form_type: FormType;
   is_required?: boolean;

   label?: string;
   display_key?: string;
   max_length?: number;
   options?: Array<any>;
   optionsUrl?: string;
   customDisplayTemplate?: (option: any) => string;
   dropdownParams?: Record<string, any>;

   allows_conditions: boolean;
}

export enum ContractTemplateFieldNameKey {
   Color = 'color',
   Comment = 'comment',
   EmploymentBox = 'employment_box',
   EmploymentCityId = 'employment_city_id',
   EmploymentHouseNumber = 'employment_house_number',
   EmploymentStreet = 'employment_street',
   InvoiceGroupId = 'invoice_group_id',
   JobFunctionId = 'job_function_id',
   ReplacementMotiveId = 'replacement_motive_id',
   Salary = 'salary',
   SalaryTypeId = 'salary_type_id',
   SalaryIncludesId = 'salary_include_id',
   WorkerStatuteId = 'worker_statute_id',
   WorkerTypeId = 'worker_type_id',
   ActivityRiskId = 'activity_risk_id',
   FulltimeWeekId = 'fulltime_week_id',
   ShiftId = 'shift_id',
   TeamId = 'team_id',
}
